<template>
    <div class="about">
        <h1>About Reeflendar</h1>
        
        <section class="intro">
            <p><strong>Reeflendar</strong> is the premier digital aquarium tracking and management tool designed for both saltwater and freshwater enthusiasts. Our mission is to simplify the way aquarists log water parameters, track tank health, and visualize historical data—helping you maintain a thriving ecosystem with ease.</p>
        </section>

        <section class="mission">
            <h2>Our Mission</h2>
            <p>We believe that data-driven aquarium management leads to healthier tanks and more successful reef-keeping. With advanced logging, analytics, and sharing features, Reeflendar provides hobbyists and professionals with the tools they need to maintain stable water conditions and avoid costly mistakes.</p>
        </section>

        <section class="expertise">
            <h2>Why Trust Reeflendar?</h2>
            <p><strong>Expertise & Experience:</strong> Reeflendar was built by aquarium hobbyists and technology professionals who understand the unique challenges of reef and freshwater tank management. Our platform is backed by industry knowledge and a passion for aquatic ecosystems.</p>
            <p><strong>Authoritative Data Tools:</strong> Our platform integrates interactive charts, AI-driven analytics, and customizable parameters to provide professional-level tracking solutions for beginners and experts alike.</p>
            <p><strong>Commitment to Trust & Security:</strong> We prioritize user privacy, offer secure Google OAuth login, and ensure that your data is always accessible and backed up.</p>
        </section>

        <section class="contact">
            <h2>Contact Us</h2>
            <p>Have questions or need support? Reach out to us:</p>
            <ul>
                <li><strong>Email:</strong> <a href="mailto:info@reeflendar.com">info@reeflendar.com</a></li>
                <li><strong>Business Address:</strong> 2863 95th St #123 Box 175, Naperville, IL 60564</li>
                <li><strong>Support Hours:</strong> Monday - Friday, 8 AM - 5 PM (CST)</li>
            </ul>
        </section>

        <section class="transparency">
            <h2>Transparency & Authenticity</h2>
            <p>Reeflendar is fully owned and operated by Nova Net LLC, a trusted name in software development. We are committed to honest business practices, data privacy, and continuously improving our platform based on user feedback.</p>
        </section>
    </div>
</template>

<script setup>
import { useHead } from '@vueuse/head';

useHead({
  title: 'Reeflendar.com - About',
  meta: [
    { name: 'description', content: 'Learn more about Reeflendar.' },
    { name: 'keywords', content: 'about, reef tank, aquarium' },
  ],
});
</script>
